import React from 'react';
import ProvisionSystemInformation from './provision-system-information';
import ProvisionLocation from './provision-location';
import ProvisionLease from './provision-lease';
import PropTypes from 'prop-types';
import { classes } from './styles/provision';
import { Button } from 'reactstrap';
import { translate } from 'react-i18next';

class ProvisionPendingProductInstanceView extends React.Component {

  render() {
    const { t, onSave, onCancel, disabled, canSave } = this.props;
    // ProvisionSystemInformation props
    const {
      systemId,
      productId,
      productVersion,
      description,
      onSystemId,
      onProductId,
      onProductVersion,
      onDescription,
      versions
    } = this.props;
    // ProvisionLocation props
    const {
      customer,
      location,
      onCustomer,
      onLocation,
      customers,
      locations
    } = this.props;
    // ProvisionLease props
    const {
      jurisdiction,
      systemStatus,
      paidThrough,
      onJurisdiction,
      onSystemStatus,
      onPaidThrough,
      jurisdictions,
      systemStatuses
    } = this.props;
    return (
      <React.Fragment>
        <h3>{t('provision.title')}</h3>
        <div className={classes.childContainer}>
          <ProvisionSystemInformation
            systemId={systemId}
            productId={productId}
            productVersion={productVersion}
            description={description}
            onSystemId={onSystemId}
            onProductId={onProductId}
            onProductVersion={onProductVersion}
            onDescription={onDescription}
            versions={versions}
            disabled={disabled}
          />
        </div>
        <div className={classes.childContainer}>
          <ProvisionLocation
            customer={customer}
            location={location}
            onCustomer={onCustomer}
            onLocation={onLocation}
            customers={customers}
            locations={locations}
            disabled={disabled}
          />
        </div>
        <div className={classes.childContainer}>
          <ProvisionLease
            jurisdiction={jurisdiction}
            systemStatus={systemStatus}
            paidThrough={paidThrough}
            onJurisdiction={onJurisdiction}
            onSystemStatus={onSystemStatus}
            onPaidThrough={onPaidThrough}
            jurisdictions={jurisdictions}
            systemStatuses={systemStatuses}
            disabled={disabled}
          />
        </div>
        <div className={classes.actionsContainer}>
          <Button
            color="primary"
            size="sm"
            disabled={!canSave || disabled}
            onClick={onSave}
          >
            {t('provision.saveAction')}
          </Button>
          <Button
            color="danger"
            size="sm"
            disabled={disabled}
            onClick={onCancel}
          >
            {t('provision.cancelAction')}
          </Button>
        </div>
      </React.Fragment>
    )
  }

}

ProvisionPendingProductInstanceView.propTypes = {
  ...ProvisionSystemInformation.propTypes,
  ...ProvisionLocation.propTypes,
  ...ProvisionLease.propTypes,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  canSave: PropTypes.bool.isRequired
};

export default translate(['pending'])(ProvisionPendingProductInstanceView);


// WEBPACK FOOTER //
// ./src/views/pending-product-instance/provision.js